import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CyTestDirective } from '@portal/directive';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'portal-form-get-address-button',
  standalone: true,
  imports: [CyTestDirective, MatIconModule],
  template: `
    <button
      class="field-single-button"
      portalCyTest="getAddress"
      [disabled]="disabled || false"
      type="button"
      (click)="emitter.emit($event)"
    >
      <mat-icon color="primary">my_location</mat-icon>
      <span>Get Address</span>
    </button>
  `,
  styles: [':host {display: block;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GetAddressButtonComponent {
  @Input() disabled?: boolean;
  @Output() emitter = new EventEmitter<MouseEvent>();
}
